// @flow

import styled from 'styled-components';

const Body = styled.div`
  padding: 0;
`;

export default Body;
